
import { useState } from 'react';
import { useCustomerDataLoader } from './useCustomerDataLoader';
import { useCustomerFormData } from './useCustomerFormData';
import { useCustomerFormSubmit } from './useCustomerFormSubmit';
import { Customer } from '@/lib/supabase/customers/types';

export const useCustomerEditForm = (customerId: string, onSuccess: () => void, shopId?: string) => {
  const { customer, loading, orders, totalSpent, organizationId } = useCustomerDataLoader(customerId);
  const { saving, formErrors, handleSave, setFormErrors } = useCustomerFormSubmit(customerId, onSuccess, shopId);
  
  const {
    name, setName,
    email, setEmail,
    phone, setPhone,
    selectedCountryCode, setSelectedCountryCode,
    country, setCountry,
    region, setRegion,
    municipality, setMunicipality,
    address, setAddress,
    errors, setErrors,
    validateForm,
    prepareCustomerData
  } = useCustomerFormData(customer);
  
  // Combined errors from form validation and API responses
  const combinedErrors = { ...errors, ...formErrors };
  
  // Handler for the save operation that combines all hooks
  const handleFormSave = async () => {
    const customerData = prepareCustomerData();
    // Add shop_id to the data if provided
    if (shopId) {
      customerData.shop_id = shopId;
    } else if (customer?.shop_id) {
      customerData.shop_id = customer.shop_id;
    }
    
    return await handleSave(customerData, validateForm);
  };
  
  return {
    customer,
    loading,
    saving,
    name, setName,
    email, setEmail,
    phone, setPhone,
    selectedCountryCode, setSelectedCountryCode,
    country, setCountry,
    region, setRegion,
    municipality, setMunicipality,
    address, setAddress,
    orders,
    totalSpent,
    organizationId,
    errors: combinedErrors,
    handleSave: handleFormSave
  };
};

// For backwards compatibility
export const useClientEditForm = useCustomerEditForm;
